import { forwardRef } from 'react';
import { BottomNav } from './BottomNav';
import { TabView } from './TabView';
import { AnnouncementBanner } from '@/components/announcements/AnnouncementBanner';
import { NavExpansionProvider } from '@/contexts/NavExpansionContext';
import { MultiSelectProvider } from '@/contexts/MultiSelectContext';

/**
 * Main app layout with bottom navigation and tab view.
 * Uses forwardRef to avoid React Router console warnings.
 */
export const AppLayout = forwardRef<HTMLDivElement>(function AppLayout(_props, ref) {
  return (
    <MultiSelectProvider>
      <NavExpansionProvider>
        <div ref={ref} className="h-[100dvh] flex flex-col overflow-hidden bg-background">
          <AnnouncementBanner />
          <main className="flex-1 overflow-hidden">
            <TabView />
          </main>
          <BottomNav />
        </div>
      </NavExpansionProvider>
    </MultiSelectProvider>
  );
});
